import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import SelectorLanguageComponent from '../../components/selector-language-component/selector-language-component';

export function CookiePolicy() {
  const { t } = useTranslation();

  return (
    <div
      className="min-h-screen pt-5"
      style={{
        background: 'linear-gradient(60deg, #13dfb6 0%,#004e78 100%)',
      }}
    >
      {/* Selector de idioma en la esquina superior */}
      <div className="absolute right-0 top-0">
        <div className="flex p-3 justify-content-end">
          <SelectorLanguageComponent />
        </div>
      </div>

      {/* Contenedor Principal */}
      <div className="flex justify-content-center pt-8 px-5 md:px-6 pb-5">
        <div className="w-full md:w-11 lg:w-9 xl:w-7 surface-100 shadow-2 text-center border-round-3xl relative p-4 md:p-5 ">
          {/* Logo */}
          <div className="col-12 text-center p-0">
            <img
              className="w-18rem lg:w-15rem"
              src="/assets/marsi-azul-degradado-fondo-blanco.webp"
              alt="Logotipo de Marsinet"
              rel="preload"
            />
          </div>

          {/* Contenido */}
          <div className="col-12 text-left px-3">
            {/* Aviso Legal */}
            <h1 className="text-4xl font-bold text-primary-500 text-center">
              <span className="text-900">
                {t('pages.register.cookiePolicyTexts.cookiePolicyTitle')}
              </span>
            </h1>
            <h2 className="text-xl font-bold text-900 text-left">
              {t(
                'pages.register.cookiePolicyTexts.informationAboutCookiesTitle'
              )}
            </h2>
            <p className="text-justify text-700 mb-5">
              {t(
                'pages.register.cookiePolicyTexts.informationAboutCookiesText'
              )}
            </p>
            {/* QUE SON */}
            <h2 className="text-xl font-bold text-900 text-left">
              {t('pages.register.cookiePolicyTexts.whatAreCookiesTitle')}
            </h2>
            <p className="text-justify text-700 mb-5">
              {t('pages.register.cookiePolicyTexts.whatAreCookiesText1')}
              <br />
              <br />
              {t('pages.register.cookiePolicyTexts.whatAreCookiesText2')}
            </p>
            {/* AFECTADAS */}
            <h2 className="text-xl font-bold text-900 text-left">
              {t(
                'pages.register.cookiePolicyTexts.cookiesAffectedByTheRegulationTitle'
              )}
            </h2>
            <p className="text-justify text-700 mb-5">
              {t(
                'pages.register.cookiePolicyTexts.cookiesAffectedByTheRegulationText'
              )}
            </p>
            {/* TIPOS */}
            <h2 className="text-2xl font-bold text-900 text-left">
              {t('pages.register.cookiePolicyTexts.typeOfCookiesTitle')}
            </h2>
            <h2 className="text-xl pl-3 font-bold text-900 text-left">
              {t('pages.register.cookiePolicyTexts.dependingOnThePurposeTitle')}
            </h2>
            <p className="pl-3 text-justify text-700 mb-5">
              •{' '}
              {t('pages.register.cookiePolicyTexts.dependingOnThePurposeText1')}
              <br />
              <br />•{' '}
              {t('pages.register.cookiePolicyTexts.dependingOnThePurposeText2')}
              <br />
              <br />•{' '}
              {t('pages.register.cookiePolicyTexts.dependingOnThePurposeText3')}
              <br />
              <br />•{' '}
              {t('pages.register.cookiePolicyTexts.dependingOnThePurposeText4')}
              <br />
              <br />•{' '}
              {t('pages.register.cookiePolicyTexts.dependingOnThePurposeText5')}
              <br />
              <br />•{' '}
              {t('pages.register.cookiePolicyTexts.dependingOnThePurposeText6')}
              <br />
              <br />•{' '}
              {t('pages.register.cookiePolicyTexts.dependingOnThePurposeText7')}
            </p>
            <h2 className="text-xl pl-3 font-bold text-900 text-left">
              {t('pages.register.cookiePolicyTexts.accordingToOwnershipTitle')}
            </h2>
            <p className="pl-3 text-justify text-700 mb-5">
              •{' '}
              {t('pages.register.cookiePolicyTexts.accordingToOwnershipText1')}
              <br />
              <br />•{' '}
              {t('pages.register.cookiePolicyTexts.accordingToOwnershipText2')}
            </p>
            <h2 className="text-xl pl-3 font-bold text-900 text-left">
              {t(
                'pages.register.cookiePolicyTexts.accordingToTheConservationPeriodTitle'
              )}
            </h2>
            <p className="pl-3 text-justify text-700 mb-5">
              •{' '}
              {t(
                'pages.register.cookiePolicyTexts.accordingToTheConservationPeriodText1'
              )}
              <br />
              <br />•{' '}
              {t(
                'pages.register.cookiePolicyTexts.accordingToTheConservationPeriodText2'
              )}
            </p>
            {/* ACEPTACION */}
            <h2 className="text-xl font-bold text-900 text-left">
              {t(
                'pages.register.cookiePolicyTexts.acceptanceRejectionOrDeletionTitle'
              )}
            </h2>
            <p className="text-justify text-700 mb-5">
              {t(
                'pages.register.cookiePolicyTexts.acceptanceRejectionOrDeletionText1'
              )}
              <br />
              <br />
              {t(
                'pages.register.cookiePolicyTexts.acceptanceRejectionOrDeletionText2'
              )}
              <br />
              <br />
              {t(
                'pages.register.cookiePolicyTexts.acceptanceRejectionOrDeletionText3'
              )}
              <br />
              <br />
              {t(
                'pages.register.cookiePolicyTexts.acceptanceRejectionOrDeletionText4'
              )}
            </p>
            {/* MODIFICAR */}
            <h2 className="text-xl font-bold text-900 text-left">
              {t(
                'pages.register.cookiePolicyTexts.changingTheCookieSettingsTitle'
              )}
            </h2>
            <p className="text-justify text-700 mb-5">
              {t(
                'pages.register.cookiePolicyTexts.changingTheCookieSettingsText1'
              )}
              <br />
              <br />
              - Internet Explorer:
              windows.microsoft.com/es-xl/internet-explorer/delete-manage-cookies#ie="ie-
              10"
              <br />
              <br />
              - Microsoft Edge:
              support.microsoft.com/es-es/help/4468242/microsoft-edge-browsing-data-and-
              privacy-microsoft-privacy
              <br />
              <br />
              - FireFox: support.mozilla.org/es/kb/Borrar%20cookies
              <br />
              <br />
              - Chrome: support.google.com/chrome/answer/95647?hl="es"
              <br />
              <br />
              - Safari: www.apple.com/es/privacy/use-of-cookies/
              <br />
              <br />
              {t(
                'pages.register.cookiePolicyTexts.changingTheCookieSettingsText2'
              )}
              <br />
              <br />
              - Ghostery: www.ghostery.com/
              <br />
              <br />- Your online choices: www.youronlinechoices.com/es/
            </p>
            {/* TRATAMIENTOS */}
            <h2 className="text-xl font-bold text-900 text-left">
              {t(
                'pages.register.cookiePolicyTexts.processingOfPersonalDataTitle'
              )}
            </h2>
            <p className="text-justify text-700 mb-5">
              {t(
                'pages.register.cookiePolicyTexts.processingOfPersonalDataText1'
              )}
              <br />
              <br />
              {t(
                'pages.register.cookiePolicyTexts.processingOfPersonalDataText2'
              )}
              <br />
              <br />
              {t(
                'pages.register.cookiePolicyTexts.processingOfPersonalDataText3'
              )}
              <br />
              <br />
              {t(
                'pages.register.cookiePolicyTexts.processingOfPersonalDataText4'
              )}
              <br />
              <br />
              {t(
                'pages.register.cookiePolicyTexts.processingOfPersonalDataText5'
              )}
            </p>
            {/* DERECHOS */}
            <h2 className="text-xl font-bold text-900 text-left">
              {t('pages.register.cookiePolicyTexts.rightsInterestedPartyTitle')}
            </h2>
            <p className="text-justify text-700 mb-5">
              -{' '}
              {t('pages.register.cookiePolicyTexts.rightsInterestedPartyText1')}
              <br />
              <br />-{' '}
              {t('pages.register.cookiePolicyTexts.rightsInterestedPartyText2')}
              <br />
              <br />-{' '}
              {t(
                'pages.register.cookiePolicyTexts.rightsInterestedPartyText3'
              )}{' '}
              <Link target="_blank" to="https://www.aepd.es/es">
                {' '}
                www.agpd.es.
              </Link>{' '}
              {t('pages.register.cookiePolicyTexts.rightsInterestedPartyText4')}
              <br />
              <br />
              <strong>
                {t(
                  'pages.register.cookiePolicyTexts.rightsInterestedPartyText5'
                )}
              </strong>
              <br />
              <br />
              MARSI BIONICS S.L Calle Marie Curie, 13, Planta 6, Edif. Bioma,
              Oficinas 1-2, 28521 Rivas-Vaciamadrid, Madrid.{' '}
              <a href="mailto:soporte.marsinet@marsibionics.com">
                soporte.marsinet@marsibionics.com
              </a>{' '}
            </p>
            {/* COOKIES */}
            <h2 className="text-xl font-bold text-900 text-left">
              {t('pages.register.cookiePolicyTexts.whatCookiesDoWeUseTitle')}
            </h2>
            <p className="text-justify text-700 mb-5">
              {t('pages.register.cookiePolicyTexts.whatCookiesDoWeUseText1')}
              <div className="pl-2">
                <h3 className="text-md font-bold text-900 text-left">
                  Cookies
                </h3>
                <p className="text-justify text-700 mb-5">
                  Google Analytics:
                  <br />
                  <br />
                  _ga
                  <br />
                  _gat
                  <br />
                  _gid
                  <br />
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText2'
                  )}
                </p>
                <h3 className="text-md font-bold text-900 text-left">
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText3'
                  )}
                </h3>
                <p className="text-justify text-700 mb-5">
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText4'
                  )}
                </p>
                <h3 className="text-md font-bold text-900 text-left">
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText5'
                  )}
                </h3>
                <p className="text-justify text-700 mb-5">
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText6'
                  )}
                </p>
                <h3 className="text-md font-bold text-900 text-left">
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText7'
                  )}
                </h3>
                <p className="text-justify text-700 mb-5">
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText8'
                  )}
                </p>
                <h3 className="text-md font-bold text-900 text-left">
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText9'
                  )}
                </h3>
                <p className="text-justify text-700 mb-5">
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText10'
                  )}
                  <div className="pl-5 space-y-3 text-justify text-700">
                    <p>
                      - Uso de las cookies de Google Analytics en los sitios
                      web:{' '}
                      <a
                        href="https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=es"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline break-words"
                      >
                        https://developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage?hl=es
                      </a>
                    </p>
                    <p>
                      - Condiciones de privacidad de Google Analytics:{' '}
                      <a
                        href="https://www.google.com/policies/privacy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline break-words"
                      >
                        https://www.google.com/policies/privacy/
                      </a>
                    </p>
                    <p>
                      - Condiciones de las cookies de Google:{' '}
                      <a
                        href="http://www.google.com/policies/technologies/types/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline break-words"
                      >
                        http://www.google.com/policies/technologies/types/
                      </a>
                    </p>
                  </div>
                </p>
                <h3 className="text-md font-bold text-900 text-left">
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText14'
                  )}
                </h3>
                <p className="text-justify text-700 mb-5">
                  {t(
                    'pages.register.cookiePolicyTexts.whatCookiesDoWeUseText15'
                  )}
                  <div className="pl-5 space-y-3 text-justify text-700">
                    <p>
                      - Facebook:{' '}
                      <a
                        href="https://www.facebook.com/privacy/explanation"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline break-all"
                      >
                        https://www.facebook.com/privacy/explanation
                      </a>
                    </p>
                    <p>
                      - Instagram:{' '}
                      <a
                        href="https://help.instagram.com/519522125107875"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline break-all"
                      >
                        https://help.instagram.com/519522125107875
                      </a>
                    </p>
                    <p>
                      - Linkedin:{' '}
                      <a
                        href="https://es.linkedin.com/legal/privacy-policy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline break-all"
                      >
                        https://es.linkedin.com/legal/privacy-policy
                      </a>
                    </p>
                    <p>
                      - Twitter:{' '}
                      <a
                        href="https://twitter.com/privacy"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline break-all"
                      >
                        https://twitter.com/privacy
                      </a>
                    </p>
                    <p>
                      - YouTube:{' '}
                      <a
                        href="https://www.google.es/intl/es/policies/technologies/cookies/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline break-all"
                      >
                        https://www.google.es/intl/es/policies/technologies/cookies/
                      </a>
                    </p>
                  </div>
                </p>
              </div>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookiePolicy;
